import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

const loading = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Loader = styled(({
  background,
  className,
  color = theme.colors.action || '#000',
  size = 16,
  strokeWidth = 2,
  ...props
}) => {
  const R = size / 2; // radius
  const C = 2 * Math.PI * R; // circumference
  return (
    <svg
      className={className}
      width={size + strokeWidth}
      height={size + strokeWidth}
      viewBox={`0 0 ${size + strokeWidth} ${size + strokeWidth}`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient x1="100%" y1="50%" x2="100%" y2="95%" id="a">
          <stop stopColor={color} stopOpacity="0" offset="0%" />
          <stop stopColor={color} stopOpacity=".631" offset="63.146%" />
          <stop stopColor={color} offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)">
          {background && (
            <circle
              stroke={background}
              strokeWidth={strokeWidth}
              cx={R}
              cy={R}
              r={R}
            />
          )}
          <circle
            cx={R}
            cy={R}
            r={R}
            stroke="url(#a)"
            strokeWidth={strokeWidth}
            strokeDasharray={C}
            strokeDashoffset={C - (C / 4)}
          />
          <circle
            fill={color}
            cx={size / 2}
            cy={size}
            r={strokeWidth / 2}
          />
        </g>
      </g>
    </svg>
  );
})`
  animation: ${loading} ${({ speed = 500 }) => speed}ms linear infinite;
`;

export default fn(__filename, Loader);



// WEBPACK FOOTER //
// ./src/components/icons/Loader.js